<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M10.5 17.5C14.6421 17.5 18 14.1421 18 10C18 5.85786 14.6421 2.5 10.5 2.5C6.35786 2.5 3 5.85786 3 10C3 14.1421 6.35786 17.5 10.5 17.5Z"
        stroke="#0C0C12" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13 7.5L8 12.5" stroke="#0C0C12" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13 12.5L8 7.5" stroke="#0C0C12" stroke-linecap="round" stroke-linejoin="round" />
</svg>